import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Company } from '@classes/company';
// import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _moment from 'moment';
import { EnvConfigurationService } from './env-configuration.service';
const moment = _moment;

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/company';

  companys: Array<Company> = [];
  lastUpdate: _moment.Moment;

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getCompanies(forceRefresh?: boolean): Observable<Array<Company>> {
    if (this.companys.length && this.lastUpdate.isBefore(moment().add(this.environment.refreshListSecond, 'second')) && !forceRefresh) {
      return of(this.companys);
    }
    return this.http.get<Array<Company>>(this.basePath).pipe(
      map(m => {
        this.companys = m;
        this.lastUpdate = moment();
        return m;
      })
    );
  }

  getCompany(id: string): Observable<Company> {
    return this.http.get<Company>(`${this.basePath}/${id}`);
  }

  createOrUpdateCompany(company?: Company): Observable<Company> {
    if (company?.id) {
      //update
      const url = `${this.basePath}/${company?.id}`;
      return this.http.patch<any>(url,
        company).pipe(map(m => {
          return m
        }));
    } else {
      //create
      return this.http.post<any>(this.basePath,
        company
      ).pipe(map(m => {
        return m
      }));
    }
  }

  deleteCompany(companyId: string): Observable<any> {
    const baseUrl = this.basePath;
    const url = `${baseUrl}/${companyId}`;
    return this.http.delete(url);
  }

}
